import { useQuery } from 'react-query';

import type { AxiosRequestConfig } from 'axios';
import _ from 'lodash';
import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { Envs, useBaseUrl, useEnvContext } from 'scbk-services/config';
import { RequestType } from 'scbk-services/http/constants';
import { BsoiService } from 'scbk-services/http/services/bsoi-service';
import { CustomAxiosRequestConfig } from 'scbk-services/types/http/axios-extension';
import { BSOIError } from 'scbk-services/types/http/bsoi-error';

export interface UseBsoiGetOptions extends AxiosRequestConfig {
    baseUrl?: string;
    cacheKey?: string;
    endpoint: string;
}

const useBsoiGet = <T>(
    options: UseBsoiGetOptions,
    queryOptions?: UseQueryOptions<T, BSOIError.Error>,
): UseQueryResult<T, BSOIError.Error> => {
    const { baseUrl, endpoint, cacheKey = endpoint, ...config } = options;
    const { getEnv } = useEnvContext();
    const { getBsoiBaseUrl } = useBaseUrl();
    const contextBaseUrl = getBsoiBaseUrl(getEnv() === Envs.MOCK);
    const targetUrl = _.isEmpty(baseUrl) ? contextBaseUrl : baseUrl;

    return useQuery<T, BSOIError.Error>(
        [cacheKey],
        async (params) => {
            return new BsoiService(targetUrl as string).get(endpoint, {
                ...config,
                params: { ...params, queryKey: undefined, signal: undefined },
                customBaseUrl: targetUrl,
                requestType: RequestType.BSOI,
            } as CustomAxiosRequestConfig);
        },
        {
            enabled: false,
            retry: false,
            ...queryOptions,
        },
    );
};

export default useBsoiGet;
